import { useMemo, useState } from 'react';
import { CalendarDateService, LocalStorageService, TimeWindow } from '@uplift/services';
import { MONTH_VALUE_FORMAT } from './components/MonthRangeFilter/MonthPicker.component';
import { TimeRange } from '@uplift/types';


const FINANCE_LOCAL_STORAGE_KEY = 'finance-filter';

const getFilterFromLocalStorage = (): TimeWindow | null => {
  const localFilter = LocalStorageService.getItem<string[]>(FINANCE_LOCAL_STORAGE_KEY);

  if (!localFilter || !Array.isArray(localFilter) || localFilter.length !== 2) {
    return null;
  }

  const from = CalendarDateService.date(localFilter[0], MONTH_VALUE_FORMAT);
  const to = CalendarDateService.date(localFilter[1], MONTH_VALUE_FORMAT);

  return {
    start: from,
    end: to,
  };
};

export const useFinanceFilters = (range: TimeRange) => {
  const serverRange: TimeWindow = useMemo(() => ({
    start: CalendarDateService.date(range.start),
    end: CalendarDateService.date(range.end),
  }), [ range ]);
  const [ rangeFilter, setRangeFilter ] = useState<TimeWindow | null>(() => {
    const localFilter = getFilterFromLocalStorage();

    return localFilter ?? serverRange ?? null;
  });

  const setRangeFilterHandler = (range: TimeWindow) => {
    LocalStorageService.setItem(FINANCE_LOCAL_STORAGE_KEY, [
      range.start.format(MONTH_VALUE_FORMAT),
      range.end.format(MONTH_VALUE_FORMAT),
    ]);

    setRangeFilter(range);
  };

  return {
    rangeFilter,
    setRangeFilter: setRangeFilterHandler,
    serverRange
  };
};
